import _ from "lodash";

export function commonPrecisionFormatter() {
  let result = this.value;
  if (_.isFinite(this.value)) {
    result = this.value.toPrecision(4);
  }

  return result;
}
